import type { DemoKey } from '../types';

export const pt: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Matemática · Estatística',
  'app.title': 'Estatística',
  'panel.experiment': 'Cena',
  'panel.params': 'Parâmetros',

  'exp.survey-explorer.title': 'Explorador de pesquisa',
  'exp.survey-explorer.desc': 'Escolha uma coluna; a demo escolhe o resumo certo.',
  'exp.distribution-sculptor.title': 'Escultor de distribuições',
  'exp.distribution-sculptor.desc': 'Arraste pontos e veja como as estatísticas reagem.',
  'exp.two-variable-lab.title': 'Laboratório bivariado',
  'exp.two-variable-lab.desc': 'Dispersão, ajuste e a pergunta sobre causalidade.',
  'exp.sampling-lab.title': 'Laboratório de amostragem',
  'exp.sampling-lab.desc': 'Como técnica e tamanho movem a média da amostra.',
  'exp.probability-diagrams.title': 'Diagramas de probabilidade',
  'exp.probability-diagrams.desc': 'Vistas Venn e árvore para eventos compostos.',

  'type.qualitative-nominal.label': 'Qualitativo · nominal',
  'type.qualitative-nominal.def': 'Categorias sem ordem intrínseca.',
  'type.qualitative-ordinal.label': 'Qualitativo · ordinal',
  'type.qualitative-ordinal.def': 'Categorias com ordem significativa.',
  'type.qualitative-multi.label': 'Qualitativo · multivalor',
  'type.qualitative-multi.def': 'Cada observação pode ter várias etiquetas.',
  'type.quantitative-discrete.label': 'Quantitativo · discreto',
  'type.quantitative-discrete.def': 'Números em passos fixos.',
  'type.quantitative-continuous.label': 'Quantitativo · contínuo',
  'type.quantitative-continuous.def': 'Números medidos em escala contínua.',

  'column.name.label': 'Nome do aluno',
  'column.height_cm.label': 'Altura',
  'column.shoe_size_eu.label': 'Tamanho de sapato (EU)',
  'column.study_hours.label': 'Horas de estudo / semana',
  'column.test_score.label': 'Nota da prova',
  'column.sports_played.label': 'Esportes praticados',
  'column.eye_color.label': 'Cor dos olhos',
  'column.commute_min.label': 'Trajeto',
  'column.grade_year.label': 'Série',
  'column.homework_effort.label': 'Esforço na lição',
  'column.ice-cream-sales.label': 'Vendas de sorvete',
  'column.drownings.label': 'Afogamentos',
  'column.month.label': 'Mês',
  'column.storks.label': 'Cegonhas',
  'column.births.label': 'Nascimentos',
  'column.country_area_km2.label': 'Área do país',
  'column.sleep_hours.label': 'Horas de sono',
  'column.reaction_ms.label': 'Tempo de reação',

  'dataset.master-survey.label': 'Pesquisa de turma',
  'dataset.master-survey.desc': '30 alunos simulados.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Vendas de sorvete vs afogamentos',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Ambos sobem e descem com a estação. Afogamentos não causam vendas de sorvete.',
  'dataset.spurious-storks-vs-births.label': 'Cegonhas vs nascimentos',
  'dataset.spurious-storks-vs-births.desc':
    'Países maiores têm mais cegonhas e mais nascimentos. As aves não são a causa.',
  'dataset.real-sleep-vs-reaction-time.label': 'Sono vs tempo de reação',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Mais sono, reações mais rápidas. Uma correlação negativa real — e um mecanismo plausível.',

  'tag.football.label': 'Futebol',
  'tag.basketball.label': 'Basquete',
  'tag.volleyball.label': 'Vôlei',
  'tag.swimming.label': 'Natação',
  'tag.none.label': 'Nenhum',

  'population.gaussian.label': 'Curva em sino',
  'population.right-skewed.label': 'Assimétrica à direita',
  'population.bimodal.label': 'Bimodal (com estratos)',
  'population.uniform.label': 'Uniforme',

  'venn.dice-even-or-prime.label': 'Dado: par ou primo',
  'venn.class-sports-2set.label': 'Esportes (2 conjuntos)',
  'venn.class-sports-3set.label': 'Esportes (3 conjuntos)',
  'venn.custom.label': 'Personalizado',

  'tree.draw-without-replacement.label': 'Retirada sem reposição',
  'tree.custom.label': 'Personalizado',
  'tree.coin.heads': 'Ca',
  'tree.coin.tails': 'Co',
  'tree.draw.start': 'Saco: 2 vermelhas, 3 azuis',
  'tree.draw.red': 'Vermelho',
  'tree.draw.blue': 'Azul',
  'tree.custom.start': 'Início',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histograma',
  'card.cumulative': 'Frequência acumulada',
  'card.box': 'Diagrama de caixa',
  'card.summary': 'Resumo de 5 números',
  'card.bar': 'Gráfico de barras',
  'card.mode': 'Moda',
  'card.tag-frequency': 'Frequência das etiquetas',
  'card.mode-tag': 'Etiqueta dominante',
  'card.empty-no-order': 'Não aplicável',
  'card.empty-multi': 'Não aplicável',
  'card.numberline': 'Reta numérica',
  'card.scatter': 'Dispersão',
  'card.description': 'O que está acontecendo',
  'card.population': 'População',
  'card.sampling-distribution': 'Médias amostrais',
  'card.venn': 'Venn',
  'card.tree': 'Árvore',
  'card.probabilities': 'Probabilidades',

  'param.dataset.label': 'Conjunto de dados',
  'param.column.label': 'Coluna',
  'param.bins.label': 'Intervalos',
  'param.shape.label': 'Forma inicial',
  'param.show-mean.label': 'Mostrar média',
  'param.show-median.label': 'Mostrar mediana',
  'param.x-col.label': 'Coluna X',
  'param.y-col.label': 'Coluna Y',
  'param.show-regression.label': 'Linha de regressão',
  'param.show-residuals.label': 'Resíduos',
  'param.show-confounder.label': 'Mostrar fator de confusão',
  'param.population.label': 'População',
  'param.technique.label': 'Técnica',
  'param.sample-size.label': 'Tamanho da amostra',
  'param.stratum.label': 'Estrato',
  'param.bias.label': 'Viés',
  'param.mode.label': 'Modo',
  'param.preset.label': 'Predefinição',
  'param.universe.label': 'Tamanho do universo',
  'param.show-prob.label': 'Mostrar probabilidades',
  'param.treat-as-numeric.label': 'Tratar como numérico',

  'stat.count': 'Contagem',
  'stat.mean': 'Média',
  'stat.median': 'Mediana',
  'stat.range': 'Amplitude',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IIQ',
  'stat.outliers': 'Outliers',
  'stat.r': 'r de Pearson',
  'stat.r2': 'r²',
  'stat.slope': 'Inclinação',
  'stat.intercept': 'Intercepto',
  'stat.n': 'n',
  'stat.population-mean': 'Média verdadeira',
  'stat.latest-sample-mean': 'Média amostral',
  'stat.sample-mean-spread': 'DP média amostral',
  'stat.sample-count': 'Amostras retiradas',
  'outlier.upper': 'Outliers superiores',
  'outlier.lower': 'Outliers inferiores',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Reamostrar',
  'btn.run-100': 'Tirar 100 amostras',
  'btn.stop': 'Parar',
  'btn.clear-history': 'Limpar histórico',

  'explainer.no-order': 'Sem ordem → sem acumulada, sem caixa.',
  'explainer.multi-no-iqr': 'Multivalor → quartis / IIQ indefinidos.',
  'message.no-data': 'Sem dados.',
  'message.needs-quartiles': 'Precisa de ≥4 pontos para quartis.',
  'message.x-zero-variance': 'X tem variância zero — nenhuma reta a ajustar.',
  'message.n-too-small': 'n muito pequeno.',
  'message.stratum-clamp': 'Estrato tinha menos linhas do que pedido — usadas todas.',
  'message.siblings-sum-to-one': 'Os filhos devem somar 1.',
};
